import React, { useEffect } from 'react';
import { useGym } from '../../DataStore/Gym/GymContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import TrainerCard from './TrainerCard';
import { Link } from 'react-router-dom';

const TrainerList = ({ onCreate }) => {
  const { getTrainerList, trainerList } = useGym();

  useEffect(() => {
    getTrainerList();
  }, []);

  return (
    <div className="main-card mb-3 card p-0">
       <div className="card-header card-title">Personal Trainers
          <div className="btn-actions-pane-right actions-icon-btn">
                <Link to="#" onClick={onCreate} className='btn-pill btn btn-outline-primary btn-sm'>New Trainer</Link>
            </div>
        </div>
    

      <div className="card-body">
        <div className="overflow-auto flex-row d-flex trainer-list">
          {/* <div className="d-flex" style={{ gap: '1.5rem' }}> */}
            {Array.isArray(trainerList) && trainerList.map(trainer => (
             <TrainerCard key={trainer.id} trainer={trainer} />
            ))}
            {!trainerList && <ActivityLoader />}
            {trainerList === '404' && <Notification message="No trainers found." closable={false} />}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default TrainerList;
